<script lang="ts">
import {auth, functions} from "../services/firebase"
import router from "page";
import { onMount } from "svelte";
import OfferGridItem from "../components/OfferGridItem.svelte";
import AddOfferItem from "../components/AddOfferItem.svelte";
import NewOfferModal from "../components/NewOfferModal.svelte";
export let qs : {offerOwner: string};
interface User {
    email: string, photoURL: string, uid: string
}

let user: User | null;
let offerDocuments = [];
let offerOwners = [];
let loading = true;
let offerOwnerName = "";


auth.onAuthStateChanged(u => user = u);

$: {
    if (user === null) router.redirect("/auth?action=login&next=%2Fdashboard");
}   
// retrieveUserOfferOwners
onMount(async ()=> {
    // functions.useEmulator("localhost", 5001)
    console.log(qs)
    try{
        const offerListFunc = functions.httpsCallable("retrieveOffers");
        let offerList;
        if(!isEmpty(qs) && qs.offerOwner != null){
            offerList = await offerListFunc({offerOwner: qs.offerOwner})
        }else{
            offerList = await offerListFunc()
        }
        console.log(offerList.data)
        offerDocuments = offerList.data
    }catch(error){
        console.log("Error retrieving user documents ", error);
    } finally{
        loading = false;
    }

    try{
        const offerOwnerList: {data: Array<{name: string, key: string}>} = await functions.httpsCallable("retrieveUserOfferOwners")();
        console.log(offerOwnerList.data)
        if(!isEmpty(qs) && qs.offerOwner != null){
            let offerOwnerObject = offerOwnerList.data.find((owner)=>{
                return owner.key == qs.offerOwner
            });
            if(offerOwnerObject != null){
                offerOwnerName = offerOwnerObject.name;
                offerOwners = [offerOwnerObject, ...offerOwnerList.data.filter((value) => {
                    return value.key != offerOwnerObject.key;
                })];
            }
        }else{
            offerOwners = offerOwnerList.data;
        }
        
    }catch(error){
        console.log("Error retrieving user offer owners ", error);
    } finally{
        loading = false;
    }
})

function logout() {
    if (auth.currentUser) {
        auth.signOut().then(() => {}).catch(e => {
            throw new Error(e)
        });
    }
}
function isEmpty(obj) { 
    for (var x in obj) { return false; }
    return true;
}
let modal;
let addItem;
</script>
<NewOfferModal bind:this={modal} bind:offerOwnerList={offerOwners} fromOwnerFolder={true} />
{#if typeof user === "undefined" || loading}
<div class="w-screen h-screen text-center justify-center i pt-6">
    <i class="fas fa-spinner fa-spin fa-5x"></i> 
    <p>Loading</p>
</div>
{:else}
    {#if user}
    <header class="flex flex-row w-full pt-2 pr-2">
        <a class="flex-1" href="/dashboard">
            <h1 class="w3-jumbo w3-center text-4xl flex-1">Persu<span style="font-family: monospace;">AI</span>d</h1>
            </a>
    <!-- w3-button w3-blue -->
    <div class="float-right justify-self-end">
        <button class="
          text-white
            hover:bg-red-300 
            p-2 
            bg-third
            rounded-lg" on:click={logout}>Logout
        </button>
    </div>
    </header>
        <br>
        <h3 class="w3-center text-center">{#if offerOwnerName != ""}{offerOwnerName+" "}{/if}Offers</h3>
        <div class="w3-container documentContainer" style="margin: 0 auto; width: 80%;"> 
                <div class="flex flex-wrap overflow-hidden lg:-mx-4 ">
                    {#if offerDocuments && offerDocuments.length >= 0}
                        <div on:click={modal.show()} on:mouseover={addItem.handleMouseOver()} on:mouseout={addItem.handleMouseOut()} 
                        class="w3-col w3-center
                        w-full overflow-hidden sm:w-1/2 lg:my-4 lg:px-4 lg:w-1/4
                        cursor-pointer
                        hover:bg-blue-600 hover:text-white">
                            <AddOfferItem 
                            bind:this={addItem}
                             title="Start an Offer"/>
                        </div>
                        {#each offerDocuments.reverse() as offer}
                        <div on:click={() => router.show(`offers/${offer.id}`)} 
                            class="w3-col
                            w-full overflow-hidden sm:w-1/2 lg:my-4 lg:px-4 lg:w-1/4
                            cursor-pointer
                            w3-hover-sand
                             hover:bg-secondary hover:text-white">
                            <OfferGridItem {...offer} />
                        </div>
                        {/each}
                    {:else}
                        <div on:click={modal.show()} class="w3-col w3-center l3 m4 s12">
                            <AddOfferItem  title="Start an Offer"/>
                        </div>
                    {/if}
                    <!-- Dummy element used to scroll chat -->
                    <br id="scroll-to">
             </div>       
            
        </div>
        <br>
    {:else}
        <p class="w3-center w3-section">Not logged in!</p>
    {/if}
{/if}

<style>
    .documentContainer {
        justify-content: center;
    }
    .w3-col{
        display: flex;
        justify-content: center;
        align-items: center;
        height: 200px;
    }
</style>